import { useMutation } from "@tanstack/react-query";
import axios from "axios";

// Absolute Completed semantics, separate from production-center status advancement.
export function useKitchenReadiness() {
    return useMutation(({ orderName, production_center, production_centers, identifiers }) =>
        axios.post("method/restaurant_management.kitchen_readiness.mark_ready", {
            order_name: orderName,
            production_centers: production_centers || [production_center],
            ...(identifiers ? { identifiers } : {}),
        })
    );
}
